import LocomotiveScroll from 'locomotive-scroll';

const _scroll = new LocomotiveScroll({
    el: document.querySelector('[data-scroll-container]'),
    smooth: true,
    getDirection: true,
    class: "is-inview",
});


export function scrollNavbar() {
    $('.c-navbar').removeClass('isSticky');
    _scroll.on('scroll', (position) => {
        if ((position.scroll.y) > 150) {
            $('.c-navbar').addClass('isSticky');
        } else {
            $('.c-navbar').removeClass('isSticky');
        }
    });

    _scroll.on('scroll', (position) => {
        if ($('.emploisTriggerBackground').hasClass('is-inview')) {
            $('body').css('backgroundColor', '#2C2C30');
        } else {
            $('body').css('backgroundColor', 'transparent');
        }
    });
}

scrollNavbar();

export function updateScroll() {
    _scroll.update();
    _scroll.start();
}

export function stopScroll() {
    _scroll.stop();
}

export function initScroll() {
    _scroll.init();
}

export function startScroll() {
    _scroll.start();
}

export function destroyScroll() {
    _scroll.destroy();
}

$(document).ready(function () {
    setTimeout(function () {
        updateScroll();
    }, 500);
});
